/** The carryover settings that apply to a dispatch, resolved from its driver's company and region. */
export type DispatchCarryoverPolicy = {
  enabled: boolean;
  afterHours: number;
  /** The most times a dispatch may carry over; absent for no limit. */
  max?: number;
  /** New dispatches start with "Don't carry over" checked. */
  excludedByDefault: boolean;
};

export type DispatchCarryoverPolicyArgs = {regionId: string; personId?: string; category?: string};

/** One day the carryover job moved a dispatch forward because it was left open while its driver was off shift. */
export type DispatchCarryover = {
  id: string;
  dispatchId: string;
  /** The driver assigned when it carried over; absent when unassigned. */
  personId?: string;
  personName?: string;
  /** 1 for the first carryover of the dispatch, 2 for the second, and so on. */
  carryoverNumber: number;
  fromScheduleDttm: number;
  toScheduleDttm: number;
  createDttm: number;
};

/** One sentence on whether and how carryover applies, for forms and profiles. */
export const describeDispatchCarryoverPolicy = (policy?: DispatchCarryoverPolicy): string | undefined => {
  if (!policy) return undefined;
  if (!policy.enabled) return "Carryover is off for this region and the driver's company, so this setting has no effect.";

  const limit = policy.max != null ? `, up to ${policy.max === 1 ? "once" : `${policy.max} times`}` : "";
  const defaults = policy.excludedByDefault ? " New dispatches skip carryover unless turned on." : "";
  return `Carryover is on: an open dispatch moves to the next day ${policy.afterHours} hours after its scheduled time while the driver is off shift${limit}.${defaults}`;
};
